export const CHAT = {
    SET_API_MODE: 'CHAT_SET_API_MODE',
    SET_API_SUBMODE: 'SET_API_SUBMODE',
    TRANSFERED_TO_AGENT: 'TRANSFERED_TO_AGENT',
    WIRTUALNY_KONSULTANT: 'wirtualny konsultant'
};
